module.exports = __webpack_public_path__ + "static/media/unlock-alt.7e572080.svg";